import { useEffect, useState } from 'react';

export default function useScrollPosition() {
  const [isOnTop, setIsOnTop] = useState(true);

  useEffect(() => {
    // Function to check scroll position
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsOnTop(true);
      } else {
        setIsOnTop(false);
      }
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isOnTop;
}
